<template lang="pug">
base-layout.authenticate
  template(v-slot:nuxt)
    k-container(small).pt-0
      k-layout-page-title {{ $route.path.indexOf('join-now') > 0 ? 'Join Kintell' : 'Sign In' }}
      k-card(box-shadow="small")
        k-card-text
          v-tabs(
            v-model="activeTab"
            color="transparent"
            slider-color="brand-pink"
            ref="tabs"
          )
            v-tab(key="join-now" to="/join-now" :ripple="false" :active-class="'font-weight-bold'").brand-dark-blue--text.mr-8 Join now
            v-tab(key="sign-in" to="/sign-in" :ripple="false"  :active-class="'font-weight-bold'").brand-dark-blue--text Sign in
          nuxt
</template>
<script>
import BaseLayout from '@/layouts/base'
import { UsesAuthenticatedUser } from '@/mixins'

export default {
  components: { BaseLayout },
  mixins: [
    UsesAuthenticatedUser
  ],
  data () {
    return {
      activeTab: this.$route.path,
    }
  },
}
</script>
<style lang="scss" scoped>
.authenticate {
  ::v-deep {
    // Slider tab CSS
    .v-slide-group__content {
      height: 37px;
    }

    .v-tabs-slider-wrapper {
      margin-right: 12px;
    }

    .v-tab {
      font-size: 18px;
      letter-spacing: 0;
      min-width: 0;
      padding: 0;
      text-transform: none;
    }
  }
}
</style>
